export function sum(numbers: readonly number[]) {
  return numbers.reduce((s, n) => s + n, 0);
}
